module.exports = __webpack_public_path__ + "static/media/narracao.c38205b1.svg";